module.exports = __webpack_public_path__ + "img/head-bg.85f23712.png";